/** Registry key for the Organization read model. */
export const ORGANIZATION_READ = 'Organization';
//# sourceMappingURL=organization.js.map